module.exports = __webpack_public_path__ + "fa577a94d6f496bf7b865b32cc23a2a3.png";


//////////////////
// WEBPACK FOOTER
// ./src/containers/diamond/images/carat_diamond_ring.png
// module id = 338
// module chunks = 0